import { IPostCheckoutCharge } from "@api-clients/charges";
import {
  loadMentionMeReferreroffer,
} from "apps/website/utils/mentionme/loadMentionMe";

export function loadMentionMeForPurchase(
  charge: IPostCheckoutCharge,
  katkinCustomerId: string,
  showPopup?: boolean,
): void {
  loadMentionMeReferreroffer({
    firstname: charge.firstName ?? "",
    surname: charge.lastName ?? "",
    email: charge.email ?? "",
    order_number: charge.chargeId,
    order_subtotal: charge.priceNoVat,
    order_currency: "GBP",
    order_date: charge.finalisedAt || charge.createdAt,
    customer_id: katkinCustomerId,
    coupon_code: charge.discountCode,
    phone_number: charge.shippingAddress?.phone,
    fullname: charge.fullName,
    address_line1: charge.shippingAddress?.address1,
    address_line2: charge.shippingAddress?.address2,
    address_city: charge.shippingAddress?.city,
    address_county: charge.shippingAddress?.province,
    address_postcode: charge.shippingAddress?.zip,
    address_country: "United Kingdom",
    custom_share_field: charge.catNames,
    custom_field: charge.catNames,
    implementation: showPopup ? "popup" : "link",
  });
}
